import { useTheme } from "@emotion/react";
import type { ComponentProps } from "react";

import { Avatar } from "@skilitics/designer-ui-components";

export interface WorkspaceAvatarProps extends ComponentProps<typeof Avatar> {
  name: string;
  // Stable identifier used to pick a consistent colour (workspace id, falling back to name).
  seed: string;
}

// Deterministic hash so the same workspace always maps to the same colour group entry.
const hashString = (value: string) => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

export const WorkspaceAvatar = ({ name, seed, style, ...avatarProps }: WorkspaceAvatarProps) => {
  const theme = useTheme();

  const initial = name.trim().charAt(0).toUpperCase();
  const backgroundColor = theme.colorGroup[hashString(seed) % theme.colorGroup.length];

  return (
    <Avatar style={{ backgroundColor, ...style }} {...avatarProps}>
      {initial}
    </Avatar>
  );
};
